import { Checkbox } from "components/ui/checkbox";

/**
 * "Include Invoice No. in PDF" toggle shown against every invoice step.
 *
 * Per the client review: "There should be a check box against Invoice No., so that in case the
 * client wants an invoice with Invoice No., we can include that." The same control was previously
 * copy-pasted into each invoice screen; this is the single shared version to wire per step.
 *
 * `id` must be unique on the page — several invoice panels can be mounted at once, and a duplicated
 * id would make the label toggle the wrong checkbox.
 */
export default function IncludeInvoiceNoCheckbox({
  id,
  checked,
  onChange,
  disabled = false,
}: {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(value) => onChange(Boolean(value))}
      />
      <label
        htmlFor={id}
        className="text-xs md:text-sm text-[#222222] cursor-pointer"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        Include Invoice No. in PDF
      </label>
    </div>
  );
}
